module.exports = __webpack_public_path__ + "static/media/逗猫棒.c51c7de7.svg";